import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { OcDropdownImports } from 'otimus-library'
import { AuthService } from 'src/app/services/auth.service'
import { InternationalizationService } from 'src/app/services/internationalization.service'
import { ProfilePicComponent } from '../../profile-pic/profile-pic.component'

@Component({
  selector: 'app-authenticated-user',
  imports: [ProfilePicComponent, ...OcDropdownImports],
  templateUrl: './authenticated-user.component.html',
  styleUrl: './authenticated-user.component.scss',
})
export class AuthenticatedUserComponent {
  constructor(
    private readonly router: Router,
    protected readonly translateService: InternationalizationService,
    protected readonly authService: AuthService
  ) {}

  protected get userTypeLabel(): string {
    const code = this.authService.user?.userType
    return code ? this.translateService.getTranslation(code) : ''
  }

  protected editProfile(): void {
    this.router.navigate(['/app/profile'])
  }

  protected logout(): void {
    this.authService.logout().subscribe()
  }
}
